module.exports = __webpack_public_path__ + "static/img/6.b974552.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/sp/6.png
// module id = 6Mey
// module chunks = 0